<template>
  <div v-if="contact">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" v-if="isNewContact">
                {{ $t('editionContact.titleCreation') }}</h1>
              <h1 class="title is-size-3" v-else>
                {{ $t('editionContact.titleChange', { nomPrenom: nomPrenom }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
          <a class="button is-cancel btn-modal-annuler "
             @click="$router.go(-1)">
            {{ $t('editionContact.actions.revert')}}
          </a>
          <a class="button is-addOrEdit "
             @click="sauvegarderContact()">
            {{ $t('general.button.sauvegarder')}}
          </a>
          </div>
        </div>
      </div>
      <div class="tab mgh-0">
        <ul>
          <li
            v-for="(tab, index) in tabs" :key="index"
            :class="{'is-active': activeTab === tab}"
            @click="activeTab = tab">
            {{ $t(`editionContact.tabs.${tab}`) }}
          </li>
        </ul>
      </div>
      <br v-if="error">
      <error-msg-component v-if="error" :messages="messagesErreur"
                            :error="error"
                            :titreMessageErreurEcran="titreMessageErreurEcran"
                            :title="'editionContact.problemOccurred'"
                            :withEmplyFields="true"
                            @close="error = $event"/>
    </div>
    <div class="pdt-20px" v-if="contact && activeTab === 'informations'">
      <div class="column is-12 columns is-multiline">
        <div class="column is-6">
          <div class="card contactEdition">
            <header class="header-card">
              <p>
                {{ $t('editionContact.generalInformations')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns is-multiline">
                <div class="column is-6 is-marginless">
                  <b-field label="Nom client"
                          class="obligatoire"
                          :type="typeTiers">
                    <b-autocomplete
                      v-model="nomClient"
                      :data="dataClients"
                      field="nomCommercialAvecVille"
                      @select="option => selectTiers(option)"
                      @input="getAsyncClientData"
                      @blur="valideSelectionNomClient"
                      :disabled="!isNewContact"
                      :loading="isFetching" >
                      <template slot="empty">
                        <span class="has-text-danger" >
                          {{ $t('editionContact.messages.selectCustomer')}}
                        </span>
                      </template>
                    </b-autocomplete>
                  </b-field>
                </div>
                <div class="column is-6 is-marginless"></div>
                <parametre-autocomplete
                  :label="$t('editionContact.civility')"
                  :target="constantes.typesParametres.PARAMETRES_KEYS.civilite"
                  v-model="contact.civiliteId"
                  expanded
                  class="column is-4"
                />
                <b-field :label="$t('editionContact.name')"
                        :type="typeNom" class="obligatoire column is-4 is-marginless">
                  <b-input v-model="contact.nom"></b-input>
                </b-field>
                <b-field :label="$t('editionContact.firstname')"
                        class="column is-4 is-marginless">
                  <b-input v-model="contact.prenom"></b-input>
                </b-field>
                <b-field :label="$t('editionContact.phone')"
                        class="column is-4 is-marginless">
                  <b-input v-model="contact.telephone"></b-input>
                </b-field>
                <b-field :label="$t('editionContact.cellPhone')"
                        class="column is-4 is-marginless">
                  <b-input v-model="contact.portable"></b-input>
                </b-field>
                <app-input-email
                  :label="$t('editionContact.email')"
                  v-model="contact.email"
                  :class="{ obligatoire: contact.accesPortail }"
                  class="column is-4 is-marginless" />
                <fonction-contact-autocomplete
                  v-model="contact.fonction"
                  :label="$t('editionContact.office')"
                  class="column is-4">
                </fonction-contact-autocomplete>
                <b-field :label="$t('editionContact.service')"
                        class="column is-4 is-marginless">
                  <b-input v-model="contact.service"></b-input>
                </b-field>
                <b-field  :label="$t('editionContact.typeContact')"
                          class="column is-4">
                  <qd-taginput v-model="typesContactSelected"
                              :data="filteredTagsTypeContact"
                              @typing="getfilteredTypeContact"
                              @input="getTypeContactTag"
                              open-on-focus
                              icon="magnify"
                              field="libelle"
                              type="is-primary"
                              expanded
                              autocomplete>
                    <template slot="empty">
                      <div>
                        {{$t('general.autocomplete.noRslt')}}
                      </div>
                    </template>
                    <template slot-scope="props">
                      {{ props.option.libelle + ' - '
                    + getTypeContactType(props.option.typeContactType) }}
                    </template>
                  </qd-taginput>
                </b-field>
                <qd-checkbox v-model="contact.newsletter"
                  class="mgt-10px column is-4">
                  <span>{{$t('editionContact.newsLetter')}}</span>
                </qd-checkbox>

                <qd-checkbox v-model="contact.adresseContactDifferente"
                            @input="selectionAdresseClient()"
                            class="mgt-10px column is-6">
                  <span>{{$t('editionContact.haveAddress')}}</span>
                </qd-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class=" column is-6" v-if="hasCreateContactUtilisateur">
          <div class="card contactEdition">
            <header class="header-card">
              <p>
                {{ $t('editionContact.identifiantDeConnexion')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <div class="column is-3">
                  <qd-switch v-model="contact.accesPortail">
                    {{ $t('editionContact.accesPortail') }}
                  </qd-switch>
                </div>
                <div class="column is-7" v-if="contact.utilisateur">
                  <b-field :label="$t('editionContact.identifiant')"
                    class="obligatoire column is-12 is-marginless pdt-0">
                    <b-input
                      :disabled="!contact.accesPortail"
                      v-model="contact.utilisateur.identifiant">
                    </b-input>
                  </b-field>
                  <b-field :label="$t('editionContact.motDePasse')"
                    class="column is-12 is-marginless"
                    :class="{'obligatoire': isNewContact}">
                    <b-input
                      :disabled="!contact.accesPortail"
                      type="password"
                      v-model="contact.utilisateur.motPasse"
                      password-reveal>
                    </b-input>
                  </b-field>
                  <b-field :label="$t('editionContact.confirmerMotDePasse')"
                    class="column is-12 is-marginless"
                    :class="{'obligatoire': isNewContact}">
                    <b-input
                      :disabled="!contact.accesPortail"
                      type="password"
                      v-model="contact.utilisateur.motPasseConf"
                      password-reveal>
                    </b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="card" v-if="contact.adresse && contact.adresseContactDifferente">
          <header class="header-card">
            <p>
              {{ $t('editionContact.address')}}
            </p>
          </header>
          <div class="card-content">
            <app-adresse :adresse="contact.adresse"
                          :tableName="TIERS"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="contact && activeTab === 'contactsTiers'">
      <contacts-tiers :contact="contact"
        :isEdit="true"
        @updateContactsTiers="handleContactsTiersChange($event)">
      </contacts-tiers>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { create, update, get as getContact } from '@/api/contacts/index';
import { get as getTiers, getAllByTradeName } from '@/api/tiers/index';
import * as types from '@/store/modules/clients-mutation-type';
import gestionType from '@/services/general/gestionType';
import contactGenerer from '@/services/tiers/genererContact';
import InputEmail from '@/components/general/inputEmail';
import Adresse from '@/components/general/adresse';
import ContactsTiers from '@/components/tiers/contacts/m_ContactsTiers';
import validation from '@/services/tiers/validationContact';
import validationUtilisateur from '@/services/parametrage/validation/validationModificationUtilisateur';
import validationContactTiers from '@/services/contact/validationTiers';
import titreMessageErreur from '@/services/tiers/titreMessageErreur';
import adresseGenerer from '@/services/general/genererAdresse';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { TIERS } from '@/configuration/ville/villeConf';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import MixinParametreInterne from '@/mixins/parametreInterne';
import genererContactUtilisateur from '@/services/contact/genererContactUtilisateur';
import { LISTE_TYPE_CONTACT_TYPE } from '@/configuration/bodac/typeContact/typeContactConf';
import fonctionContactAutocomplete from '@/components/commun/contact/fonctionContactAutocomplete';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Clients = createNamespacedHelpers('clients');
const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'edition-contact',
  mixins: [MixinParametreInterne],
  components: {
    appInputEmail: InputEmail,
    appAdresse: Adresse,
    AppBreadcrumb,
    errorMsgComponent,
    ContactsTiers,
    fonctionContactAutocomplete,
    parametreAutocomplete,
  },
  data() {
    return {
      TIERS: TIERS,
      nomClient: null,
      error: false,
      contact: null,
      isNewContact: true,
      isFetching: false,
      dataClients: [],
      titreMessageErreurEcran: '',
      messagesErreur: [],
      nomPrenom: '',
      tiers: null,
      typesContactSelected: [],
      filteredTagsTypeContact: [],
      activeTab: 'informations',
      constantes: {
        TAB_CONTACTIERS: 'contactsTiers',
        TAB_INFORMATIONS: 'informations',
        typesParametres,
      },
    };
  },
  computed: {
    ...Clients.mapGetters({
      clients: 'clients',
      getContacts: 'contacts',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societesInformations: 'societesInformations',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    tabs() {
      return this.modulePortailClientActive ? [
        this.constantes.TAB_INFORMATIONS,
        this.constantes.TAB_CONTACTIERS,
      ] : [this.constantes.TAB_INFORMATIONS];
    },
    columns() {
      return ['tiersId', 'delete'];
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeContacts.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeContacts.title'), route: { name: 'l.bodac.clients/contacts-contacts' }, isActive: false },
        { title: this.$i18n.t('editionContact.titleChange', { nomPrenom: this.nomPrenom }), route: { name: 'm.bodac.clients/contacts-editContact' }, isActive: true },
      ];
      if (this.isNewContact) {
        output[2].title = this.$i18n.t('editionContact.titleCreation');
        output[2].route = { name: 'm.bodac.clients/contacts-addContact' };
      }
      return output;
    },
    contacts: {
      get() {
        return this.getContacts;
      },
      set(value) {
        this.setContacts(value);
      },
    },
    typeNom() {
      return gestionType(this.contact.nom, this.error);
    },
    typeTiers() {
      return gestionType(this.contact.tiersId, this.error);
    },
    modulePortailClientActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key);
    },
    hasCreateContactUtilisateur() {
      return (this.$route.params.isFromBailleur && this.modulePortailBailleurActive)
        || (this.modulePortailClientActive && !this.$route.params.isFromBailleur);
    },
    typesContact() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.typeContact);
    },
  },
  methods: {
    ...Clients.mapMutations({
      setContacts: types.SET_CONTACT,
      editContact: types.EDIT_CONTACT,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    getAsyncClientData: debounce(function ClientData() {
      if (!this.nomClient) {
        this.contact.tiersId = null;
      }
      this.dataClients = [];
      this.isFetching = true;
      getAllByTradeName(this.nomClient, this.societeActiveId,
        TIERS_TYPE_CLIENT, [TIERS_SOUS_TYPE_AUCUN]).then((response) => {
        response.data.result.items.forEach((client) => {
          if (!client.archive) {
            client.nomCommercialAvecVille = client.code + ' - ' + client.nomCommercial + ' - ' + adressFullStringGetter(client.adressePostale, false);
            if (client.compteComptable) {
              client.nomCommercialAvecVille += ' - ' + client.compteComptable;
            }
            this.dataClients.push(client);
          }
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, 500),
    handleContactsTiersChange(contactsTiers) {
      if (contactsTiers) {
        this.contact.contactsTiers = contactsTiers;
      }
    },
    valideSelectionNomClient() {
      if (!this.contact.tiersId) {
        this.nomClient = null;
      }
    },
    selectTiers(tiers) {
      if (tiers) {
        this.contact.tiersId = tiers.id;
        this.tiers = cloneDeep(tiers);
      }
    },
    preSauvegarde() {
    },
    validationSauvegarde() {
      this.messagesErreur = [];
      if (!this.nomClient && !this.contact.tiersId
      || this.contact.tiersId === undefined) {
        this.messagesErreur.push({
          message: 'editionContact.customerName',
        });
      } else if (this.nomClient && !this.contact.tiersId) {
        this.messagesErreur.push({
          message: 'editionContact.messages.customerNameNotExist',
        });
      }
      this.error = validation(this.contact, this.messagesErreur);
      this.error = this.error && this.messagesErreur.length > 0;
      if (this.error) {
        this.titreMessageErreurEcran = 'editionContact.' + titreMessageErreur(this.isNewClient, this.messagesErreur);
      }
    },
    async sauvegarderContact() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.preSauvegarde();
        this.validationSauvegarde();
        if (this.error) {
          loadingComponent.close();
          return;
        }
        let messageToast = '';
        let response = null;
        if (!this.contact.accesPortail) delete this.contact.utilisateur;
        this.contact.typesContactIds = this.typesContactSelected.map(tc => tc.id);
        const contact = cloneDeep(this.contact);
        contact.lienTiersId = cloneDeep(this.contact).contactsTiers?.map(dt => dt.id);
        if (contact.contactsTiers) delete contact.contactsTiers;
        if (this.isNewContact) {
          response = await create(contact);
          this.contacts.push(response.data.result);
          messageToast = this.$i18n.t('editionContact.messages.successCreation');
        } else {
          if (contact.utilisateur
          && !contact.utilisateur.motPasse) contact.utilisateur.motPasse = null;
          response = await update(contact);
          this.editContact(response.data.result);
          messageToast = this.$i18n.t('editionContact.messages.successChange');
        }
        loadingComponent.close();
        if (response) {
          this.$router.push({
            name: 'c.bodac.clients/contacts-contacts',
            params: {
              id: response.data.result.id,
              isFromBailleur: this.$route.params.isFromBailleur,
            },
          });
          messageSucces(messageToast);
        } else {
          Error('');
        }
      } catch (e) {
        if (e.response?.data?.error) {
          this.messagesErreur = [];
          validationUtilisateur(e.response, '', [], this.messagesErreur, []);
          validationContactTiers(e.response, this.messagesErreur, this.$i18n);
          this.error = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    selectionAdresseClient() {
      if (!this.contact.adresseContactDifferente) {
        this.contact.adresse = adresseGenerer();
      }
    },
    getTypeContactType(value) {
      const find = LISTE_TYPE_CONTACT_TYPE.find(el => el.value === value);
      if (find) return this.$t(find.libelle);
      return '';
    },
    getTypeContactTag() {
      this.filteredTagsTypeContact = this.typesContact.filter((el) => {
        return !this.typesContactSelected.find((elSelected) => elSelected.id === el.id);
      });
    },
    getfilteredTypeContact(text) {
      const filters = this.typesContact
        .filter((tc) => tc.libelle
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0);
      this.filteredTagsTypeContact = filters
        .filter(tc => !(this.typesContactSelected
          .map(type => type.id)
          .includes(tc.id)));
    },
    setTypesContactSelected(typesContactIdSelected) {
      this.typesContactSelected = this.typesContact
        .filter(tc => typesContactIdSelected
          && typesContactIdSelected.includes(tc.id));
      this.filteredTagsTypeContact = this.typesContact.filter((el) => {
        return !this.typesContactSelected.find((elSelected) => elSelected.id === el.id);
      });
    },

  },
  async mounted() {
    await this.loadParametres([
      typesParametres.PARAMETRES_KEYS.typeContact,
    ]);
    await this.loadParametresInterne([
      typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key,
    ]);

    if (!this.$route.params.id) {
      this.contact = contactGenerer();
      this.setTypesContactSelected(this.contact.typesContactIds);
      this.setInformationPage(this.$t('pageGescom.contact.creation'));
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    this.isNewContact = false;
    this.id = this.$route.params.id;
    try {
      const contactResponse = await getContact(this.id);
      this.contact = { ...contactResponse.data.result };
      this.setTypesContactSelected(this.contact.typesContactIds);
      this.tiers = (await getTiers(this.contact.tiersId)).data.result;
      this.nomClient = this.tiers.nomCommercial;
      if (!this.contact.accesPortail && !this.contact.utilisateur
          && (this.modulePortailBailleurActive || this.modulePortailClientActive)) {
        this.contact.utilisateur = genererContactUtilisateur();
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.modification', { item: nomPrenomGetter(this.contact) }));
    this.nomPrenom = cloneDeep(nomPrenomGetter(this.contact));
  },
};
</script>

<style scoped lang="scss">
  .contactEdition{
    .column {
      padding:6.5px!important;
    }
  }
</style>
